import { useEffect, useState } from 'react';
import Notification from '../../components/form-components/Notification';
import { useNavigate } from 'react-router-dom';
import { API_PATH } from '../../App';

const AdminLocation = () => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    locations: [],
    isLoaded: false,
    notificationHeader: null,
    notificationMesssage: null,
  });

  const [selectedLocations, setSelectedLocations] = useState(new Set());

  const onDeleteClick = () => {
    if (selectedLocations.size > 0) {
      deleteSelectedLocations();
    } else {
      console.log('Please select at least one of the location to delete');
    }
  };

  const deleteSelectedLocations = () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      // Append JWT
      const payload = Array.from(selectedLocations);
      const requestOption = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: myHeaders,
      };
      fetch(`${API_PATH}v1/admin/deleteLocations`, requestOption)
        .then((response) => response.json())
        .then((data) => {
          const newLocationsToDisplay = state.locations.filter(
            (location) => !selectedLocations.has(location.id)
          );
          setState((state) => ({
            ...state,
            locations: newLocationsToDisplay,
            notificationHeader: 'Deletion Successful',
            notificationMessage: `${selectedLocations.size} location(s) successfully deleted.`,
          }));
          setSelectedLocations(new Set());
          setTimeout(() => {
            setState((prev) => ({
              ...prev,
              notificationHeader: null,
              notificationMessage: null,
            }));
          }, 2000);

          // Show success message at the top, scroll up
          console.log('data', data);
        });
    } catch (err) {
      console.log('There is an error while executing ', err);
    }
  };

  const onToggleCheckbox = (id) => {
    const newSelectedLocations = new Set(selectedLocations);
    if (newSelectedLocations.has(id)) {
      newSelectedLocations.delete(id);
    } else newSelectedLocations.add(id);
    setSelectedLocations(newSelectedLocations);
  };

  useEffect(() => {
    try {
      fetch(`${API_PATH}v1/admin/locations`)
        .then((response) => {
          console.log('response', response);
          return response.json();
        })
        .then((data) => {
          console.log(data);
          setState((prev) => ({
            ...prev,
            locations: data.locations ?? [],
            isLoaded: true,
          }));
        });
    } catch (err) {}
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div
        aria-live="assertive"
        className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
      >
        <Notification
          notificationHeader={state.notificationHeader}
          notificationMessage={state.notificationMessage}
          onRemoveNotification={() => {
            setState((prev) => ({
              ...prev,
              notificationHeader: null,
              notificationMessage: null,
            }));
          }}
        ></Notification>
      </div>
      <div className="px-4 sm:px-6 lg:px-8 pt-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold leading-6 text-gray-900">
              Food Category
            </h1>
            <p className="mt-2 text-sm text-gray-700">
              A list of all the food categories in your account.
            </p>
          </div>
          <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none flex space-x-4">
            <button
              type="button"
              className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              onClick={() => {
                navigate('/admin/location/0');
              }}
            >
              Add New
            </button>
            <button
              type="button"
              className="block rounded-md bg-red-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
              onClick={onDeleteClick}
            >
              Delete
            </button>
          </div>
        </div>
        <div className="-mx-4 mt-8 sm:-mx-0">
          <table className="rounded min-w-full divide-y divide-gray-300 ">
            <thead>
              <tr>
                <th scope="col" className="relative py-3.5 pl-3 pr-4">
                  <span className="sr-only">Checkbox</span>
                </th>
                <th
                  scope="col"
                  className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900"
                >
                  Location Name
                </th>
                <th scope="col" className="relative py-3.5 pl-3 pr-4">
                  <span className="sr-only">Edit</span>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {state.locations.map((location) => (
                <tr key={location.id}>
                  <td className="py-4 px-3">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      checked={selectedLocations.has(location.id)}
                      onChange={() => onToggleCheckbox(location.id)}
                    />
                  </td>
                  <td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none">
                    {location.location_name}
                  </td>

                  <td className="py-4 px-3 py-3.5 text-left text-right text-sm font-medium">
                    <a
                      href={`/admin/location/${location.id}`}
                      className="text-indigo-600 hover:text-indigo-900 px-3 py-3.5 text-left"
                    >
                      Edit
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminLocation;
